import { CommonController } from './CommonController';
import { MoviePlayer } from '../modules/MoviePlayer';
import { HomeSlider } from '../modules/Slider'

export class HomeController extends CommonController {
  onInit() {
    super.onInit();
  }
  onLoad() {
    super.onLoad();
    
    new HomeSlider();
    new MoviePlayer();
  }
  onDestroy() {
    super.onDestroy();
  }
}
